import type { BLOCK_TYPE } from '../enums'

import type { IBlock, BlockBaseSettings } from './base'

export enum PAYMENT_METHOD {
  BANK_TRANSFER = 'BankTransfer',
  SEPA = 'SEPA'
}

export interface SEPASettings {
  /**
   * Labels for the fields in the Payment Method block
   * @deprecated possibly not necessary, to cross-check
   */
  fieldLabels?: {
    accountOwner?: string
    bankName?: string
    consentLabel?: string
  }
  /**
   * This URL is used to check if the provided IBAN is valid.
   * The value is added to this URL as a query parameter.
   */
  accountNumberValidationURL: string
}

export interface IPaymentMethod {
  /** Describes the payment method */
  type: PAYMENT_METHOD
  /** Human-friendly label */
  label: string
}

export interface BankTransfer extends IPaymentMethod {
  type: PAYMENT_METHOD.BANK_TRANSFER
}

export interface SEPA extends IPaymentMethod {
  type: PAYMENT_METHOD.SEPA
  settings: SEPASettings
}

export type AnyPaymentMethod = BankTransfer | SEPA

export interface PaymentMethodBlock extends IBlock {
  type: BLOCK_TYPE.PAYMENT_METHOD
  settings: BlockBaseSettings & {
    inputUIPattern: string
    /**
     * Indicates which payment methods is pre-selected
     *
     * If `undefined`, no method is pre-selected although options can be presented
     * in radio buttons depending on the settings.
     */
    preselectedMethod?: PAYMENT_METHOD
    /** Allowed payment methods */
    implementations: AnyPaymentMethod[]
  }
}

export interface IPaymentMethodBlockValue {
  /** Which payment method was selected */
  type: 'payment_invoice' | 'payment_sepa'
  /**
   * Human friendly label for the selected payment, as per the settings
   * @deprecated should come from settings instead, no need to repeat
   */
  label?: string
}

export interface BankTransferPaymentMethodValue
  extends IPaymentMethodBlockValue {
  type: 'payment_invoice'
}

export interface SEPAPaymentMethodValue extends IPaymentMethodBlockValue {
  type: 'payment_sepa'
  /** Additional data according to the selected method */
  data?: {
    fullname?: string
    iban?: string
    consent?: boolean
    bic_number?: string
    bank_name?: string
  }
}

/**
 * Represents the value stored for the Payment Method block.
 * Matches the shape used by the runtime payment control.
 */
export type PaymentMethodBlockValue =
  | BankTransferPaymentMethodValue
  | SEPAPaymentMethodValue
